<template>
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="35"
      height="35"
      rx="17.5"
      fill="#4BB8D0"
      fill-opacity="0.2"
    />
    <g clip-path="url(#clip0_703_9231)">
      <path
        d="M20.5312 5.78125C20.5312 7.45536 19.1741 8.8125 17.5 8.8125C15.8259 8.8125 14.4688 7.45536 14.4688 5.78125C14.4688 4.10714 15.8259 2.75 17.5 2.75C19.1741 2.75 20.5312 4.10714 20.5312 5.78125Z"
        fill="#4BB8D0"
        stroke="#DBF1F6"
        stroke-width="0.5"
      />
      <path
        d="M22.1875 10H12.8125C12.3152 10 11.8383 10.1975 11.4867 10.5492C11.135 10.9008 10.9375 11.3777 10.9375 11.875V21.25H13.75V13.75H14.2188V32.5H17.2656V21.7188H17.7344V32.5H20.7812V13.75H21.25V21.25H24.0625V11.875C24.0625 11.3777 23.865 10.9008 23.5133 10.5492C23.1617 10.1975 22.6848 10 22.1875 10V10Z"
        fill="#4BB8D0"
      />
    </g>
    <defs>
      <clipPath id="clip0_703_9231">
        <rect
          width="30"
          height="30"
          fill="white"
          transform="translate(2.5 2.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
